import { defineStore } from 'pinia'
import type { User } from '~/types/index'

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        user: {
            id: null,
            email: '',
            name: '',
            is_email_verified: false,
            is_profile_completed: false,
            is_profile_verified: false,
            profile_photo_url: '',
            type: '',
            has_experience: undefined,
            is_rejected: false,
            rejected_reason: '',
    } as User,
  }),
    getters: {
        isAuth(state): boolean {
            return state.user.id !== null
        },
        isEmailVerified(state): boolean {
            return state.user.is_email_verified
        },
        isProfileCompleted(state): boolean {
            return state.user.is_profile_completed
        },
        isProfileVerified(state): boolean {
            return state.user.is_profile_verified
        },
        isUnderReview(state): boolean {
            return state.user.is_profile_completed
                && !state.user.is_profile_verified
                && !state.user.is_rejected
        },
        isRejected(state): boolean {
            return state.user.is_rejected ?? false
        },
        rejectedReason(state): string {
            return state.user.rejected_reason ?? ''
        }
    },
    actions: {
        setUser(payload: User) {
            this.user = payload
        },
        clearRejection() {
            this.user.is_rejected = false
            this.user.rejected_reason = ''
        },
        resetUser() {
            this.user = {
                id: null,
                email: '',
                name: '',
                is_email_verified: false,
                is_profile_completed: false,
                is_profile_verified: false,
                profile_photo_url: '',
                type: '',
                has_experience: undefined,
                is_rejected: undefined,
                rejected_reason: '',
      }
        },
        setUserProfilePhoto(payload: string) {
            this.user.profile_photo_url = payload
        }
    }
})
